export const shouldNotRenderErrorsInBusinessAddressWhenKYBTheme = ({ templateTheme, ...rest }) => {
  const KYBTheme = "KYB";
  return KYBTheme !== templateTheme?.name;
};
